import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { setChartOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
export const hideValueFlags = createReducer(false, on(setChartData, (state, { chartData }) => chartData.params.hideValueFlags), on(setChartOption, (state, action) => {
    if (action.chartOption.value === FundChartOptionValue.HIDE_VALUE_FLAGS) {
        return action.chartOption.selected;
    }
    return state;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.HIDE_VALUE_FLAGS];
}));
